import createAction from "redux-actions/es/createAction";
import { validateUserCreds as validateUserCredsApi } from "../api/index";
import { reminderEmail as reminderEmailApi } from "../api/index";
import { retryLaterFailureTriaging as retryLaterFailureTriagingApi } from "../api/index";
import { optOutFailureTriaging as optOutFailureTriagingApi } from "../api/index";
import { optingOutEmail as optingOutEmailApi } from "../api/index";
import { saveSalesforceOrgDetails as saveSalesforceOrgDetailsApi } from "../api/index";
import { fetchSignIn as customerLoginAction } from "../../login/actions/index";
import { getPageState as getPageStateApi } from "../../customer/api/index";
import { uiEarlyFeedback as uiEarlyFeedbackApi } from "../../customer/api/index";
import { getAuth } from "../../customer/actions/index";
// import { toastr } from "react-redux-toastr";
import {SALESFORCE_LOGIN_SUCCESS_MESSAGE, SALESFORCE_LOGIN_ERROR_MESSAGE} from '../../../config';

export const salesForceStart = createAction("SALESFORCE_LOGIN_START");
export const salesForceSuccess = createAction("SALESFORCE_LOGIN_SUCCESS");
export const salesForceUpdate = createAction("SALESFORCE_LOGIN_UPDATE");
export const salesForceFail = createAction("SALESFORCE_LOGIN_FAIL");
export const salesForceClear = createAction("SALESFORCE_LOGIN_CLEAR");

export const salesForcePropcessStart = createAction(
  "SALESFORCE_LOGIN_PROCESS_START"
);
export const salesForcePropcessSuccess = createAction(
  "SALESFORCE_LOGIN_PROCESS_SUCCESS"
);
export const salesForcePropcessFail = createAction(
  "SALESFORCE_LOGIN_PROCESS_FAIL"
);
export const salesForcePropcessClear = createAction(
  "SALESFORCE_LOGIN__PROCESSCLEAR"
);

export const salesForceEmailStart = createAction("SALESFORCE_EMAIL_START");
export const salesForceEmailSuccess = createAction("SALESFORCE_EMAIL_SUCCESS");
export const salesForceEmailFail = createAction("SALESFORCE_EMAIL_FAIL");

export const salesForceLoginStatus = createAction("SALESFORCE_LOGIN_STATUS");
export const salesForceOpingOutStatus = createAction("SALESFORCE_OPTING_OUT_STATUS");


export const salesForceEmailOptingOutStart = createAction(
  "SALESFORCE_EMAIL_OPTING_OUT_START"
);
export const salesForceEmailOptingOutSuccess = createAction(
  "SALESFORCE_EMAIL_OPTING_OUT_SUCCESS"
);
export const salesForceEmailOptingOutFail = createAction(
  "SALESFORCE_EMAIL_OPTING_OUT_FAIL"
);

export const salesForceCustomerInfomationStart = createAction(
  "SALESFORCE_CUSTOMER_INFORMATION_START"
);
export const salesForceCustomerInfomationSuccess = createAction(
  "SALESFORCE_CUSTOMER_INFORMATION_SUCCESS"
);
export const salesForceCustomerInfomationFail = createAction(
  "SALESFORCE_CUSTOMER_INFORMATION_FAIL"
);

export const salesForceLogin = (data, token) => {
  return async (dispatch) => {
    dispatch(salesForceFail(''));
    dispatch(salesForceLoginStatus(false));
    await validateUserCredsApi(data, token)
      .then((res) => {
        if (res?.status === "Failed") {
          // let data = res?.data?.builds;
          dispatch(salesForceLoginStatus('false'));
          dispatch(salesForceFail(SALESFORCE_LOGIN_ERROR_MESSAGE));
        } else {
          dispatch(salesForceSuccess(res.data));
          dispatch(salesForceLoginStatus(true));
        }
      })
      .catch((err) => {
        dispatch(salesForceLoginStatus(false));
        dispatch(salesForceFail(SALESFORCE_LOGIN_ERROR_MESSAGE));
      });
  };
};
export const saveSalesforceOrgDetails = (data, token) => {
  return async (dispatch) => {
    await saveSalesforceOrgDetailsApi(data, token)
      .then((res) => {
        dispatch(salesForcePropcessSuccess(res.data));
      })
      .catch((err) => {
        dispatch(salesForcePropcessFail(err));
      });
  };
};

export const optingOutEmail = (data, token) => {
  return async (dispatch) => {
    await optingOutEmailApi(data, token)
      .then((res) => {
        let data = {
          flag: true,
          message: res.data,
        };
        // toastr.success("Email Sent Confirming Opting Out", res.data);
        dispatch(salesForceEmailOptingOutSuccess(data));
      })
      .catch((err) => {
        dispatch(salesForceEmailOptingOutFail(err));
      });
  };
};
export const reminderEmail = (data, token) => {
  return async (dispatch) => {
    await reminderEmailApi(data, token)
      .then((res) => {
        let data = {
          flag: true,
          message: res.data,
        };
        // toastr.success("Email Sent For The User To Return Later", res.data);
        dispatch(salesForceEmailSuccess(data));
      })
      .catch((err) => {
        dispatch(salesForceEmailFail(err));
      });
  };
};

export const getPageState = (data, token) => {
  return async (dispatch) => {
    await getPageStateApi(data, token)
      .then((res) => {
        dispatch(salesForceCustomerInfomationSuccess(res.data));
        // let dataUser=res.data;
        // dataUser['stageOn']="failure-triaging";
      })
      .catch((err) => {
        dispatch(salesForceCustomerInfomationFail(err));
      });
  };
};
export const retryLater = (data, token) => {
  return async (dispatch) => {
    await uiEarlyFeedbackApi(data, token)
      .then((res) => {
        // toastr.success("Email Sent For The User To Return Later", res.data);
        // dispatch(salesForceCustomerInfomationSuccess(res.data));
      })
      .catch((err) => {
        dispatch(salesForceCustomerInfomationFail(err));
      });
  };
};
export const optOutFailureTriaging = (data, token) => {
  return async (dispatch) => {
    await optOutFailureTriagingApi(data, token)
      .then((res) => {
         dispatch(salesForceOpingOutStatus(res.data));
      })
      .catch((err) => {
        dispatch(salesForceOpingOutStatus(false));
      });
  };
};

export const retryLaterFailureTriaging = (data, token) => {
  return async (dispatch) => {
    await retryLaterFailureTriagingApi(data, token)
      .then((res) => {
        //  dispatch(salesForceOpingOutStatus(res.data));
      })
      .catch((err) => {
        // dispatch(salesForceOpingOutStatus(false));
      });
  };
};

//

export const salesForceUserLogin = (data) => {
  return async (dispatch) => {
    await dispatch(customerLoginAction(data));
  };
  
};



export const getAuthCall=(data)=>{
  return async (dispatch) => {
    await dispatch(getAuth(data));
  };
}


export const getPageStateSF = (idata, token) => {
  return  (dispatch) => {
     dispatch(getPageState(idata, token))
  };
};